module.exports = __webpack_public_path__ + "static/media/balance-m.2bbbd995.svg";